import { useMemo } from 'react'

import { TreeSelect } from '@/ui/Select'
import { Routes } from './components/Routes'
import { useWorkstationSelect } from '../hooks/useWorkstationSelect'
import { useGetUserInfo } from '@/modules/Auth'
import { DateInput } from '@/components/DateInput'

import styles from './Workstation.module.scss'
import { NIGHT_SHIFT_END_HOUR } from '@/modules/Auth/helpers/useNightShiftInfo'
import { checkDate } from './checkDate'

export const Workstation = () => {
    const { data: userInfo, isLoading } = useGetUserInfo()
    const { options, selectedValue, handleWorkstationChange } = useWorkstationSelect()

    // If user is a night shift user
    // And the time is before 5am
    // Then prevent user selecting the current day, and default to the previous day
    const disableDateFrom = useMemo(() => {
        if (!userInfo?.lastSessionDetails.isNightShift) {
            return
        }

        return checkDate(new Date(), NIGHT_SHIFT_END_HOUR)
    }, [userInfo])

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <TreeSelect
                    placeholder="Workstation"
                    options={options}
                    value={selectedValue}
                    disabled={!options.length}
                    onChange={handleWorkstationChange}
                />
                {!isLoading && userInfo && <DateInput disableDateFrom={disableDateFrom} />}
            </div>
            <Routes />
        </div>
    )
}
